import axios from "axios";
import Errores from "@/utils/Errores";

export const ApiDirectorio = {
  obtenerInformacion: async (componente, tokenBearer) => {
    try {
      const response = await axios.get(JSONPARAMETROS, {
        headers: {
          Authorization: `Bearer ${tokenBearer}`
        }
      });

      if (response.data) {
        const parametros = response.data.reduce((acc, elemento) => {
          acc[elemento.llave] = elemento;
          return acc;
        }, {});

        let resultadoEtapa = "";
        let etapaVitrina = "";
        if (parametros.etapa) {
          switch (parametros.etapaVitrina.valor) {
            case "0":
              etapaVitrina = "NORMAL";
              break;
            case "1":
              etapaVitrina = "COMPLEMENTARIO";
          }
          switch (parametros.etapa.valor) {
            case "0":
              resultadoEtapa = "REGISTRO_ANTICIPADO";
              break;
            case "1":
              resultadoEtapa = "POSTULACION";
              break;
            case "2":
              resultadoEtapa = "NORMAL";
              break;
            case "3":
              resultadoEtapa = "LISTA_DE_ESPERA";
              break;
            case "4":
              resultadoEtapa = "COMPLEMENTARIO";
              break;
            case "5":
              resultadoEtapa = "RESULTADO_FINAL";
              break;
          }
          return {
            parametroModoRecuperarPassword: parametros.modoRecuperarPassword,
            parametroMostrarVacantes: parametros.mostrarVacantes,
            parametroMostrarProcedimientosEspeciales:
              parametros.mostrarProcedimientosEspeciales,
            parametroModoEnvioCorreo: parametros.modoEnvioCorreo,
            etapaVitrina,
            resultadoEtapa
          };
        } else {
          console.error("Respuesta de API incorrecta");
          return null;
        }
      }
    } catch (error) {
      Errores.switchErrors(error, componente);
      console.error(
        "Error al cargar parámetros iniciales:",
        error.response || error.message || error
      );
      return null;
    }
  }
};

export default ApiDirectorio;



// WEBPACK FOOTER //
// ./src/services/ApiDirectorio.js